import React from 'react'
import { ConfigProvider, Flex } from 'antd'
import DomainSettingsTab, {
    IDomainSettingsTab,
    IDomainSettingsTabState,
} from '../abstract-domain-settings-tab/abstract-domain-settings-tab'
import { GeneralSettingsWell } from './general-settings-well'
import { VERTICAL_WELL_GAP } from '../../theme/constants'
import { getClassNames } from '../../_utils/classnames'

import './domain-segmentation-settings.scss'

interface IDomainSegmentationSettings extends IDomainSettingsTab {}

interface IState extends IDomainSettingsTabState {}

class DomainSegmentationSettings extends DomainSettingsTab<IDomainSegmentationSettings, IState> {
    public render() {
        return (
            <Flex vertical gap={VERTICAL_WELL_GAP} className={getClassNames('domain-segmentation-settings')}>
                <ConfigProvider
                    theme={{
                        components: {
                            Form: {
                                itemMarginBottom: 0,
                                labelColor: 'var(--ant-color-secondary)',
                            },
                        },
                    }}
                >
                    <GeneralSettingsWell
                        loading={this.state.loading}
                        domain={this.state.domain!}
                        onDomainUpdated={this.handleDomainUpdated}
                    />
                </ConfigProvider>
            </Flex>
        )
    }
}

export default DomainSegmentationSettings
